import React from 'react';

import { TableFooter, TableRow } from '@mui/material';

interface IProps {
  children: React.ReactNode;
  textAlign?: 'right' | 'center';
}

const TableTotalFooter = React.memo(({ children, textAlign = 'right' }: IProps) => (
  <TableFooter>
    <TableRow sx={{ '& td:not(:first-of-type)': { textAlign, fontWeight: 'bold' } }}>
      {children}
    </TableRow>
  </TableFooter>
));

export default TableTotalFooter;
